import contentAnimations from '../js/modules/contentAnimations';
import siteNav from '../js/modules/siteNav';
import carouselCard from '../js/modules/carouselCard';
import carouselReview from '../js/modules/carouselReview';
import siteMenu from '../js/modules/siteMenu';
import tabGroup from '../js/modules/tabGroup';
import panelCollapse from '../js/modules/panelCollapse';
import skipNav from '../js/modules/skipNav';
import basketBtn from '../js/modules/basketBtn';
import sliderHero from '../js/modules/sliderHero';

// Props
import '../scss/_props.scss';

// Reset
import '../scss/_reset.scss';

// Animations
import '../scss/animations/base.scss';

// Utils
import '../scss/utils/_accessability.scss';
import '../scss/utils/_animations.scss';
import '../scss/utils/_colors.scss';
import '../scss/utils/_typography.scss';
import '../scss/utils/_richtext.scss';
import '../scss/utils/_spacing.scss';
import '../scss/utils/_responsive.scss';
import '../scss/utils/_ui.scss';

// Layouts
import '../scss/layouts/container_article.scss';
import '../scss/layouts/container_standard.scss';
import '../scss/layouts/grid_featured-collections.scss';

// Elements
import '../scss/elements/badge_standard.scss';
import '../scss/elements/btn_collection-filter.scss';
import '../scss/elements/btn_collection.scss';
import '../scss/elements/btn_direction.scss';
import '../scss/elements/btn_page-dir.scss';
import '../scss/elements/btn_standard.scss';
import '../scss/elements/btn_large.scss';
import '../scss/elements/input_text.scss';
import '../scss/elements/label_error.scss';
import '../scss/elements/label_standard.scss';

// Blocks
import '../scss/blocks/bar_announcement.scss';
import '../scss/blocks/bar_key-point.scss';
import '../scss/blocks/bar_trustpilot-rating.scss';
import '../scss/blocks/card_article.scss';
import '../scss/blocks/card_cta.scss';
import '../scss/blocks/card_product.scss';
import '../scss/blocks/card_review.scss';
import '../scss/blocks/card_info.scss';
import '../scss/blocks/card_small-collection.scss';
import '../scss/blocks/carousel_card.scss';
import '../scss/blocks/carousel_reviews.scss';
import '../scss/blocks/footer_site.scss';
// import '../scss/blocks/form_search.scss';
import '../scss/blocks/header_site.scss';
import '../scss/blocks/header_page.scss';
import '../scss/blocks/hero_cta.scss';
import '../scss/blocks/hero_large.scss';
import '../scss/blocks/hero_image.scss';
import '../scss/blocks/menu_site.scss';
import '../scss/blocks/nav_breadcrumb.scss';
import '../scss/blocks/nav_quick-links.scss';
import '../scss/blocks/nav_skip.scss';
import '../scss/blocks/nav_pagination.scss';
import '../scss/blocks/notice_standard.scss';
// import '../scss/blocks/nav_site.scss';
import '../scss/blocks/panel_embed.scss';
import '../scss/blocks/panel_explainer.scss';
import '../scss/blocks/panel_faq.scss';
import '../scss/blocks/panel_content.scss';
import '../scss/blocks/panel_social-feed.scss';
import '../scss/blocks/panel_featured-articles.scss';
import '../scss/blocks/panel_nl.scss';
import '../scss/blocks/panel_three-col.scss';
import '../scss/blocks/panel_split.scss';
import '../scss/blocks/panel_collapse.scss';
import '../scss/blocks/panel_inline-collapse.scss';
import '../scss/blocks/slider_hero.scss';
import '../scss/blocks/tab_group.scss';
import '../scss/blocks/tile_collection.scss';
import '../scss/blocks/tile_section.scss';

// Third-party overrides
import '../scss/third-party-overrides/override_okendo.scss';
import '../scss/third-party-overrides/override_rebuy.scss';
import '../scss/third-party-overrides/override_recharge-non-portal.scss';
import '../scss/third-party-overrides/override_zendesk.scss';

// Init modules
siteNav();
carouselCard();
carouselReview();
siteMenu();
tabGroup();
contentAnimations();
panelCollapse();
skipNav();
basketBtn();
sliderHero();
